import { observable, action, toJS, computed } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { getCurrentApp } from "app/api/localTools"
import { pureBeautifyObj } from "../vendor/util"

export default class Filter {
  store
  url
  @observable tableData = []
  @observable totalCount = 0
  @observable keywords = ""
  @observable currentPageIndex = 1
  @observable apps = []
  @observable tableData = []
  @observable recoveryTableData = []
  @observable totalCount = 0
  @observable currentPageIndex = 1
  @observable queryMap = {
    belong: null,
    app: null,
    start: null,
    end: null,
    offset: 0,
    limit: 10,
    keywords: null,
    unread: false,
    appIds: [],
  }

  constructor(store, url) {
    this.store = store
    this.url = url
  }

  @action updatePageIndex = index => this.currentPageIndex = index

  @action getTableData = () => {
    return request.get(`${config.backend}/${this.url}`)
      .query(this.processQueryMap)
      .checkToken()
      .dataListDispose()
  }

  @computed get processQueryMap() {
    const resule = toJS(this.queryMap)
    resule.appIds = resule.appIds.join(',')

    return resule
  }

  @action filterData = (newQueryMap) => {
    this.tableData = []
    this.updateQueryMap(newQueryMap)
    this.initOffset()
    return this.getTableData()
      .then(
        res => {
          this.updateTableData(res)
          this.initPageIndex()
        }
      )
  }

  @action changePagin = (selectedPageNumber) => {
    this.updatePageIndex(selectedPageNumber)
    this.updateQueryMap({ offset: (selectedPageNumber - 1) * this.queryMap.limit })
    this.getTableData()
      .then(
        res => {
          this.updateTableData(res)
        }
      )
  }

  @action getApps = (type, query = {}) => {
    let handler
    switch (type) {
      case 'withAll':
        handler = (res) => {
          this.apps = [{ id: "all", name: "全部" }, ...res]
        }
        break
      default:
        handler = (res) => {
          this.apps = res
        }
        break
    }

    request.get(`${config.backend}/${getCurrentApp()}/apps`)
      .query(query)
      .checkToken()
      .commonDispose()
      .then(handler)
  }

  @action selectAllApp = () => {
    const allAppId = this.apps.map(app => {
      return app.id
    })
    allAppId.shift()
    return allAppId
  }

  @action updateTableData = (data) => {
    this.totalCount = data.totalCount
    this.tableData = data.dataList
  }

  @action initOffset = () => {
    this.queryMap.offset = 0
  }

  @action updateQueryMap = (data) => {
    this.queryMap = { ...this.queryMap, ...data }
  }

  @action initPageIndex = () => {
    this.currentPageIndex = 1
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/list.js